var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',[_vm._v("بحث")])
}
var staticRenderFns = []

export { render, staticRenderFns }